"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.284 0 8.003 7.282.722 0H.691L0 .692l7.296 7.296L0 15.285l.707.707 7.296-7.296 7.296 7.296.627-.626v-.162L8.71 7.988 15.926.773V.611L15.315 0h-.031Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.956 11.201.81.054.013.85l11.148 11.147L.013 23.145l.796.795 11.147-11.148L23.104 23.94l.795-.795-11.147-11.148L23.899.85l-.795-.796-11.148 11.147Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.942 14.935 1.079.072.018 1.133l14.864 14.863L.018 30.86l1.06 1.06 14.864-14.864L30.806 31.92l1.06-1.06-14.863-14.864L31.866 1.133l-1.06-1.06-14.864 14.862Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    d: "M24 22.697 1.303 0 0 1.303v.046l22.674 22.674L0 46.697v.045l1.249 1.249h.108L24 25.348 46.643 47.99h.108L48 46.742v-.045L25.326 24.021 48 1.35v-.046L46.697 0 24 22.697Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    d: "M32 30.262 1.737 0 0 1.737v.061L30.232 32.03 0 62.262v.061l1.665 1.665h.144L32 33.797l30.191 30.191h.144L64 62.323v-.061L33.768 32.03 64 1.798v-.061L62.263 0 32 30.262Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconClose = function IconClose(_ref) {
  var sizeProp = _ref.size,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img"
  }, props, {
    iconClass: "Close"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconClose.sizes = [16, 24, 32, 48, 64];
IconClose.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
IconClose.defaultProps = {
  size: '32',
  title: 'Close',
  ariaHidden: false,
  className: undefined
};
var _default = IconClose;
exports.default = _default;